import { useEffect } from 'react';
import { useStepContext } from '../contexts/stepContext';
import { useSubscriptionContext } from '../contexts/subscriptionContext';
import { useAppSelector, useTrack } from '../hooks';
import { LocaleText } from '../LocaleText';
import { Footer } from '../components/Footer';
import { formatDiscountValue } from '../utils/formatDiscount';
import type { BenefitReminderNode } from '../types';

export const BenefitsReminderStep = ({
  // step unused for now, but declared for consistency with other steps
  step: _step
}: {
  step: BenefitReminderNode;
}) => {
  const { dispatch } = useStepContext();
  const subscription = useSubscriptionContext();
  const track = useTrack();

  // Get order item to check for existing discount
  const orderItem = useAppSelector(state => state.order_items.find(oi => oi.subscription === subscription.public_id));

  const discountPercentage = orderItem?.discount_percentage ?? 0;

  // Format discount - truncate trailing zeroes
  const formattedDiscount = formatDiscountValue(discountPercentage.toString(), 'Discount Percent');

  // Track shown event on mount
  useEffect(() => {
    track('subscriptioncancel_benefitsreminder_shown', {
      subscriptionId: subscription.public_id
    });
  }, [track, subscription.public_id]);

  function handleKeepSubscription() {
    track('subscriptioncancel_completed_saved_benefitskept', {
      subscriptionId: subscription.public_id
    });
    dispatch({ type: 'accepted' });
  }

  return (
    <div className="og-benefits-reminder-step">
      <div className="og-dialog-body">
        <p className="og-retention-discount-description">
          <LocaleText t="description" />
        </p>

        <div className="og-retention-discount og-benefits-reminder">
          <div className="og-retention-discount-content">
            <h2 className="og-retention-discount-heading" data-testid="benefit-discount-heading">
              <LocaleText t="benefitHeading" parameters={{ discount: formattedDiscount }} />
            </h2>
            <div className="og-retention-discount-subheading">
              <LocaleText t="benefitsList" />
            </div>
          </div>

          <button
            className="og-button og-retention-discount-cta"
            data-variant="primary"
            onClick={handleKeepSubscription}
          >
            <LocaleText t="acceptButton" />
          </button>
        </div>
      </div>

      <Footer />
    </div>
  );
};
